import { ref } from "firebase/storage";
import { firebaseStorage } from "@/helpers/firebase/firebase";
import { ImageSizes } from "@/enums/images-sizes";
import { CacheTypes } from "@/enums/cache-types";
import { fetchPicture } from "./PictureService";
import type { PictureResult } from "@/types/picture";

// 3 months TTL for photos (MD5 hash validation handles invalidation)
const PHOTO_TTL = 90 * 24 * 60 * 60 * 1000;

export async function getPhotoFromFirestorage(
  groupId: string,
  photoId: string,
  picturePath: string,
  format: ImageSizes = ImageSizes.SD,
): Promise<PictureResult> {
  const formatReference = ref(
    firebaseStorage,
    `groups/${groupId}/${picturePath}${format}`,
  );
  const fallbackReference = ref(
    firebaseStorage,
    `groups/${groupId}/${picturePath}`,
  );

  return fetchPicture({
    cacheType: CacheTypes.Photo,
    cacheId: `${groupId}:${photoId}`,
    formatReference,
    fallbackReference,
    format,
    callerTtlMs: PHOTO_TTL,
    setterTtlMs: PHOTO_TTL,
  });
}
